const mediaQueryList = window.matchMedia('(min-width: 768px)');
window.addEventListener('load', () => {
  function scrollFunc(event) {
    if (!event.matches) {
      const posObj = {
        "spBnr": document.querySelector('.c-bnr_sp'),
        "posShow": window.innerHeight
      }

      const header = document.querySelector('#header')

      let prevY = window.scrollY; // 前回のスクロール位置を初期化
      const headerHeight = header.clientHeight
      posObj.spBnr.remove()
      header.appendChild(posObj.spBnr)

      window.addEventListener('scroll', () => {

        const bnrFunc = () => {
          const scroll = window.scrollY
          const addShow = posObj.posShow
          console.log(scroll,addShow);


          if(scroll < addShow) {
            posObj.spBnr.classList.add('hide')
            posObj.spBnr.classList.remove('show')
          } else if(addShow <= scroll) {
            posObj.spBnr.classList.remove('hide')
            posObj.spBnr.classList.add('show')
          }
        }

      bnrFunc()

      const currentY = window.scrollY; // 現在のスクロール位置を取得
        if (currentY < prevY) { // 上にスクロールしている場合
          header.style.transform = `none`
        } else { // 下にスクロールしている場合
          if (currentY > 100) { //Safariなどのバウンススクロール対策
            header.style.transform = `translateY(-${headerHeight - 1}px)`
          }
        }
        prevY = currentY; // 前回のスクロール位置を更新
      });
    }
  }
  // regist listener
  mediaQueryList.addEventListener("change", scrollFunc);
  // init
  scrollFunc(mediaQueryList);
})